import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const getAllRates: UseCase<RateRepository, 'getAllRates'> = repository => {
  return async (payload) => {
    return await repository.getAllRates(payload)
  }
}
